import React from 'react';
import { 
  HeartPulse, 
  Landmark, 
  ShoppingCart, 
  Factory, 
  GraduationCap, 
  Truck, 
  ArrowRight 
} from 'lucide-react';

export default function IndustriesWeServe() {
  const industries = [
    {
      title: 'Healthcare',
      icon: HeartPulse,
    },
    {
      title: 'Finance',
      icon: Landmark,
    },
    {
      title: 'Retail',
      icon: ShoppingCart,
    },
    {
      title: 'Manufacturing',
      icon: Factory,
    },
    {
      title: 'Education',
      icon: GraduationCap,
    },
    {
      title: 'Logistics',
      icon: Truck,
    },
  ];

  return (
    <section className="w-full bg-[#f8f9fa] py-14 font-sans text-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          {/* LEFT CONTENT AREA */}
          <div className="lg:col-span-4 space-y-4 text-left pr-0 lg:pr-4">
            {/* Tagline */}
            <p className="text-xs font-bold tracking-widest text-[#f25c05] uppercase">
              INDUSTRIES WE SERVE
            </p>

            {/* Main Title */}
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#111111] leading-tight tracking-tight">
              Intelligent Solutions for Every Industry
            </h2>

            {/* Subtext */}
            <p className="text-gray-500 text-xs sm:text-sm leading-relaxed max-w-sm">
              We deliver domain-specific solutions that address real-world challenges and drive measurable results.
            </p>

            {/* CTA Button */}
            <div className="pt-2">
              <a
                href="/industries"
                className="inline-flex items-center space-x-2 bg-[#f25c05] hover:bg-[#d95000] text-white font-semibold text-xs px-5 py-2.5 rounded-lg shadow-sm hover:shadow transition-all duration-200 group"
              >
                <span>View All Industries</span>
                <ArrowRight className="w-3.5 h-3.5 stroke-[2.5] group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>

          {/* RIGHT CARDS GRID */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3.5">
              {industries.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div
                    key={index}
                    className="bg-white rounded-2xl p-5 border border-gray-100/80 shadow-[0_4px_20px_rgba(0,0,0,0.02)] flex flex-col items-center justify-center text-center aspect-square hover:shadow-md hover:-translate-y-1 transition-all duration-200 cursor-pointer group"
                  >
                    {/* Lucide Icon */}
                    <div className="mb-3 text-[#f25c05] group-hover:scale-110 transition-transform duration-200">
                      <IconComponent className="w-9 h-9 stroke-[1.8]" />
                    </div>

                    {/* Title */}
                    <span className="text-xs font-bold text-gray-900 tracking-tight">
                      {item.title}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}